import {Command, isNodeSelection, mergeAttributes, Node,} from '@tiptap/core'
import {NodeSelection, TextSelection} from '@tiptap/pm/state'
import {Injector} from "@angular/core";
import {RiktekstRedigeringPdfSideskiftKomponent} from "../../komponenter/pdf-sideskift/pdf-sideskift";
import {AngularNodeViewRenderer} from "web-ng2/delt/komponenter/skjema/riktekst-redigering/ngx-tiptap/src/lib/NodeViewRenderer";
import {erBarnAvNodeMedType} from "web-ng2/delt/komponenter/skjema/riktekst-redigering/tiptap/tiptapHjelpere";
import {NodeType} from "web-ng2/delt/komponenter/skjema/riktekst-redigering/tiptap/TipTapEditor";

/**
 * Legger til funksjon for å legge til sideskift-element som fører til sideskift i genererte pdfer
 * Basert på https://www.tiptap.dev/api/nodes/horizontal-rule
 */
export const Sideskift = (injector: Injector): Node => {
    return Node.create({
        name: NodeType.SideSkift,
        group: 'block',
        addOptions() {
            return {
                HTMLAttributes: {
                    'data-pdfsideskift': 'true',
                    style: 'page-break-after: always',
                    title: 'page break'
                }
            }
        },
        parseHTML() {
            return [
                {tag: 'div[data-pdfsideskift]'},
                /** ckeditor generer: <div style="page-break-after:always"><span style="display:none">&nbsp;</span></div> */
                {
                    tag: 'div',
                    getAttrs: (node) => (node as HTMLElement).style.pageBreakAfter === 'always' ? {} : false,
                    preserveWhitespace: false
                }
            ];
        },
        renderHTML({HTMLAttributes}) {
            return ['div', mergeAttributes(this.options.HTMLAttributes, HTMLAttributes)];
        },
        addNodeView() {
            return AngularNodeViewRenderer(RiktekstRedigeringPdfSideskiftKomponent, {injector});
        },
        addCommands(): SideskiftKommandoer<Command> {
            return {
                leggTilSideSkift: () => ({chain, state}) => {
                    const {selection} = state;
                    const {$from: $originFrom, $to: $originTo} = selection;

                    //kan ikke legge til sidebrekk inne i tabell
                    if (erBarnAvNodeMedType($originFrom, NodeType.Table)) return false;

                    const kjede = chain();
                    if ($originFrom.parentOffset === 0) {
                        kjede.insertContentAt({from: Math.max($originFrom.pos - 1, 0), to: $originTo.pos}, {type: this.name});
                    } else if (isNodeSelection(selection)) {
                        kjede.insertContentAt($originTo.pos, {type: this.name});
                    } else {
                        kjede.insertContent({type: this.name})
                    }

                    return kjede
                      // set cursor after horizontal rule
                      .command(({tr, dispatch}) => {
                          if (!dispatch) return true;
                          const {$to} = tr.selection
                          const posAfter = $to.end()

                          if ($to.nodeAfter) {
                              if ($to.nodeAfter.isTextblock) tr.setSelection(TextSelection.create(tr.doc, $to.pos + 1))
                              else if ($to.nodeAfter.isBlock) tr.setSelection(NodeSelection.create(tr.doc, $to.pos))
                              else tr.setSelection(TextSelection.create(tr.doc, $to.pos))

                          } else {
                              // add node after horizontal rule if it’s the end of the document
                              const node = $to.parent.type.contentMatch.defaultType?.create()
                              if (node) {
                                  tr.insert(posAfter, node)
                                  tr.setSelection(TextSelection.create(tr.doc, posAfter + 1))
                              }
                          }

                          tr.scrollIntoView()
                          return true
                      })
                      .run();
                }
            }
        },

    });
}


// typedefinisjoner

interface SideskiftKommandoer<ReturnType> {
    /** Legger til et sideskift-element som fører til sideskift i genererte pdfer */
    leggTilSideSkift: () => ReturnType
}

//for at kommandoene skal dukke opp i editor ts typen
declare module '@tiptap/core' {
    interface Commands<ReturnType> {
        sideskift: SideskiftKommandoer<ReturnType>;
    }
}
